import repository from '@/repositories/Repository'

const resource = '/accounts'

export default {
  get(companyCode, loginId) {
    return repository.bizoo
      .get(`${resource}/${companyCode}/${loginId}`)
      .then(r => r.data)
  },
}
